import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';

import { REQUEST_QUOTE_FORM } from '../../../constants/globals';
import Input from '../../common/formComponents/Input';

const formName = REQUEST_QUOTE_FORM;

export class RequestQuoteForm extends Component {
  constructor(props) {
    super(props);
    this.initializeForm();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(value) {
    const { onSubmit, handleSubmit }  = this.props;
    handleSubmit(onSubmit)(value);
  }

  initializeForm() {}

  render() {
    return (
      <form onSubmit={this.onSubmit} id={formName}>
        <Grid container spacing={40}>
          <Grid item xs={6}>
            <Field
              id="name"
              name="name"
              label="Your Name"
              fullWidth
              component={Input}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              id="email"
              name="email"
              label="Your Email"
              type="email"
              fullWidth
              component={Input}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              id="message"
              name="message"
              label="Additional Message"
              fullWidth
              multiline
              component={Input}
              rows="3"
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

RequestQuoteForm.propTypes = {
  // props from the parent component
  onSubmit: PropTypes.func.isRequired,

  // redux-form props
  handleSubmit: PropTypes.func.isRequired,
}

const formConfig = {
  form: formName
};

export default reduxForm(formConfig)(RequestQuoteForm);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Report/RequestQuoteForm.jsx